// Ekipman Yönetimi (WMS: toplama arabaları, paketleme rafları, kargo ayarları) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.equipment';

export const wmsEquipmentGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Ekipman Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Akıllı depoda kullanılan toplama arabalarını, paketleme raflarını (bölmeleriyle) ve kargo firması bağlantılarını burada tanımlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Depo ve özet kartları'),
    tabs: t(`${G}.regions.tabs`, 'Ekipman sekmeleri'),
    body: t(`${G}.regions.body`, 'Liste ve işlemler'),
  },
  navItems: [
    t(`${G}.nav.carts`, 'Toplama Arabaları'),
    t(`${G}.nav.shelves`, 'Paketleme Rafları'),
    t(`${G}.nav.cargo`, 'Kargo Ayarları'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Depoyu seçin'),
      text: t(`${G}.s1.text`, 'Sağ üstten akıllı depoyu seçin. Kartlar Toplama Arabası, Paketleme Rafı, Kargo Ayarı ve Aktif Araba sayılarını gösterir. Sekme başlıklarındaki sayılar da o depoya aittir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Toplama arabaları'),
      text: t(`${G}.s2.text`, '"Toplama Arabaları" sekmesinde "Her İkisi", "Tekli Arabalar" ve "Çoklu Arabalar" alt sekmeleri vardır. "Araba Ekle" ile Araba Kodu ve Araba Adı (zorunlu), Araba Tipi, Durum (Müsait, Kullanımda, Bakımda) ve Aktif bilgisini girin. Toplayıcı iş emrine başlarken arabanın barkodunu okutur.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tekli araba yalnız tekli, çoklu araba yalnız çoklu iş emrine verilebilir; "Her ikisi (tekli + çoklu)" tipindeki araba ikisinde de kullanılır.'),
        t(`${G}.s2.tip2`, 'İş emri hazırlanırken yalnız aktif ve "Müsait" arabalar seçilebilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Paketleme rafları ve bölmeler'),
      text: t(`${G}.s3.text`, '"Paketleme Rafları" sekmesinde "Raf Ekle" ile Raf Kodu, Raf Adı ve Bölme Sayısı (1–52) girin; bölme kodları otomatik verilir (ör. KOD-A, KOD-B). Satırdaki etiket düğmesi raf / bölme barkodunu basar. Rafı açınca bölmeler, durumları ve içindeki sipariş no görünür; "dolu / toplam" etiketi dolu bölme sayısını gösterir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Bölmeyi boşaltın'),
      text: t(`${G}.s4.text`, '"Bölmeyi Temizle" bölmenin sipariş bağlantısını kaldırır ve bölmeyi "Boş" yapar. Siparişin durumu ve stok değişmez; yalnız bölme yeniden kullanılabilir olur. Bölmede gerçekten ürün kalmadığından emin olun.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Kargo ayarları'),
      text: t(`${G}.s5.text`, '"Kargo Ayarları" sekmesinde "Kargo Firması Ekle" ile firmayı seçin; API URL, API Key, API Secret, Hesap/Müşteri Kodu ve Gönderen Bilgileri (ad, telefon, adres, il, ilçe) girin. "Varsayılan kargo firması" işaretlenen firma bu deponun varsayılanı olur, diğerinin işareti kalkar. "Test Et" bağlantıyı dener ve sonucu gösterir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Düzenlerken API Key / Secret alanını boş bırakırsanız kayıtlı değer korunur; değiştirmek için yenisini yazın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s6.title`, '6. Silme kuralları'),
      text: t(`${G}.s6.text`, 'Kalem simgesi düzenler, çöp kutusu siler; silmeden önce onay sorulur. Kullanımda olan araba silinemez. İçinde aktif sipariş bulunan bölmesi olan raf silinemez; raf silinince bölmeleri de silinir.'),
    },
  ],
});
